export const environment = {
  KeycloakConfig: {
    clientId: 'inxt',
    realm: 'LTM',
    url: 'https://inxtiam-ltisb.armadaapps.io/'
  },
  AppName: "",
  InternalDomain: "ltm.com",
  production: false,
  BASE_URL: "https://comincmapi-ltisb.armadaapps.io/api/",
  HUB_URL: "https://comincmalt-ltisb.armadaapps.io/",
  HELP_URL: "https://cominhelpd-ltisb.armadaapps.io/help/",
  BASE_FILE_PATH: "https://comincmapi-ltisb.armadaapps.io/",
  File_Path: 'https://comincmui-ltisb.armadaapps.io/',
  GIS_URL: "https://conminesgis-dev.mt-geospatial.com/api/", // "https://stagegeospatial.digital.lntecc.com/utcl-api/",
  GIS_API_KEY: "",
  GIS_URL_WithoutKey: "https://conminesgis-dev.mt-geospatial.com/api/",
  MINE_KPI_BASE_URL: "https://cominfaapidev-ltisb.armadaapps.io/v2/api/",
  token: "",
  NxtPlatform: "https://comincsapidev-ltisb.armadaapps.io/api/",
  DeviceManagement: "https://comindcapidev-ltisb.armadaapps.io/api/",
  CORE_URL: "https://comincsapidev-ltisb.armadaapps.io/api/",
  // HMI worker allocation details
  HMI_URL: "https://nxtplatformapidev-ltisb.armadaapps.io/devicemanagement/api/GatewayCommand/SendCommand",
  CustomerID: 1,
  TenantID: "ULT_WA",
  DeviceID: "",
  Subject: "workerallocation",
  contentType: "application/json",
  //HMI GSM Based
  HMI_GSM_URL: "https://nxtplatformapidev-ltisb.armadaapps.io/Devicemanagement/api/AzureIot/CloudToDevice",
  appInsights: {
    instrumentationKey: ''
  },
  SDS_URL: "https://cominmeengdev-ltisb.armadaapps.io/",
  cloud: "Aws" // Azure or Aws
};
